import React, { useEffect, useState } from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "./MapComponent.scss";
import { Icon } from "leaflet";

function MapComponent({ lat, lng, name}) {

  const markers = [
    {
      geocode: [lat, lng],
      popUp: name
    }
  ];

  const customIcon = new Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
    iconSize: [38, 38] // size of the icon
  });

  const [, setZoomValue] = useState(13);

  useEffect(() => {
    setZoomValue(13);
  }, []);

  return (
      <MapContainer center={markers[0].geocode} zoom={15} >
        <TileLayer
          attribution=''
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
              {markers.map((marker) => (
                <Marker position={marker.geocode} icon={customIcon}>
                  <Popup>{marker.popUp}</Popup>
                </Marker>
              ))}
    </MapContainer>
  );
}

export default MapComponent;
